/* GDLJ theme JS — mobile menu, product form, AJAX cart drawer (Shopify Cart API). */
(() => {
  const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const money = (c) => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(c / 100);

  // Mobile menu
  $$('[data-menu-toggle]').forEach((btn) => btn.addEventListener('click', () => {
    const menu = $('[data-mobile-menu]'); const open = menu.hidden;
    menu.hidden = !open; btn.setAttribute('aria-expanded', open);
    $('[data-icon-open]', btn).hidden = open; $('[data-icon-close]', btn).hidden = !open;
  }));
  $$('[data-mobile-menu] a').forEach((a) => a.addEventListener('click', () => $('[data-menu-toggle]')?.click()));

  // Drawer
  const drawer = $('#CartDrawer');
  const openDrawer = async () => { await renderCart(); drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); };
  const closeDrawer = () => { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); };
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-cart-close]')) closeDrawer();
  });
  document.addEventListener('keydown', (e) => e.key === 'Escape' && closeDrawer());

  async function renderCart() {
    const cart = await (await fetch('/cart.js')).json();
    $$('[data-cart-count]').forEach((n) => (n.textContent = cart.item_count));
    $('[data-cart-summary]').textContent = cart.item_count ? `${cart.item_count} item${cart.item_count === 1 ? '' : 's'}` : 'Your bag is empty';
    $('[data-cart-footer]').hidden = !cart.item_count;
    $('[data-cart-subtotal]').textContent = money(cart.total_price);
    $('[data-cart-items]').innerHTML = cart.items.length ? cart.items.map((i) => `
      <div class="gd-line">
        <div class="gd-line__img">${i.image ? `<img src="${i.image}" alt="">` : ''}</div>
        <div style="min-width:0"><p class="truncate text-xs font-bold uppercase">${i.product_title}</p><p class="mt-1 text-xs text-muted-foreground">${i.variant_title || ''}</p><p class="mt-2 text-sm font-semibold">${money(i.final_price)}</p></div>
        <div class="flex flex-col items-end justify-between">
          <button type="button" data-line="${i.key}" data-set="0" aria-label="Remove">✕</button>
          <div class="gd-line__qty"><button type="button" data-line="${i.key}" data-set="${i.quantity - 1}" aria-label="Decrease">−</button><span class="w-5 text-center text-xs">${i.quantity}</span><button type="button" data-line="${i.key}" data-set="${i.quantity + 1}" aria-label="Increase">+</button></div>
        </div>
      </div>`).join('') : '<p class="pt-16 text-center text-sm text-muted-foreground">Your bag is empty.</p>';
  }
  drawer?.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-line]'); if (!b) return;
    await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: b.dataset.line, quantity: +b.dataset.set }) });
    renderCart();
  });

  // Product form
  $$('[data-product-root]').forEach((root) => {
    const idInput = $('[data-variant-id]', root), add = $('[data-add]', root), price = $('[data-price]', root);
    $$('[data-variant]', root).forEach((b) => b.addEventListener('click', () => {
      $$('[data-variant]', root).forEach((x) => x.classList.remove('is-active')); b.classList.add('is-active');
      idInput.value = b.dataset.variant; price.textContent = b.dataset.price;
      const ok = b.dataset.available === 'true'; add.disabled = !ok; add.textContent = ok ? 'Add to bag' : 'Sold out';
    }));
    const qv = $('[data-qty-value]', root), qi = $('[data-qty-input]', root);
    $$('[data-qty]', root).forEach((b) => b.addEventListener('click', () => { const n = Math.min(10, Math.max(1, +qi.value + +b.dataset.qty)); qi.value = n; qv.textContent = n; }));
    $('[data-product-form]', root)?.addEventListener('submit', async (e) => {
      e.preventDefault(); add.disabled = true;
      await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: +idInput.value, quantity: +qi.value }] }) });
      add.disabled = false; openDrawer();
    });
  });
})();
